import { Helmet } from "react-helmet-async";
import { Container, Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDashboardContext } from "../../../context-state/DashboardContext";
import { LinksSection } from "./LinksSection";
import { getPageTitleByDomain } from "../../../utils/market";
import { useOverrideMsg } from "../../../hooks/useOverrideMsg";
import { usePermissionContext } from "../../../context-state/PermissionContext";
import { useAuthContext } from "../../../context-state/AuthContext";
import { useEffect } from "react";
import { PermissionService } from "../../../services/permissionService";
import { LinearLoader } from "../../../components/linear-loader/LinearLoader";

export default function LinksPage() {

    const { eventContext } = useDashboardContext();
    const { getEvent } = eventContext
    const { eventId } = useParams();
    const event = getEvent(eventId)
    const { lookForEventWarnings } = useOverrideMsg()
    const { account } = useAuthContext()
    const { collaboratesContext, inviteesContext, ownerContext } = usePermissionContext();
    const { collaboratesByAccount, setCollaboratesToAccount } = collaboratesContext
    const { setInviteesToAccount } = inviteesContext
    const { setAccountOwner } = ownerContext

    const collaboratesForThisAccount = collaboratesByAccount[account._id]

    const getCollaboratesDataForThisAccount = async () => {
        try {
            const { collaborates, invitees, owner } = await PermissionService.getAccountCollaboratorsData(account.owner, account._id)
            if (!collaborates) {
                throw Error('Failed get collaborates')
            }
            // Invitees
            setInviteesToAccount(account._id, invitees)
            // Collaborates
            setCollaboratesToAccount(account._id, collaborates)
            // Owner
            setAccountOwner(owner)
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (!collaboratesForThisAccount) {
            getCollaboratesDataForThisAccount()
        }
    }, [collaboratesForThisAccount])

    lookForEventWarnings(event)

    if (!collaboratesForThisAccount) {
        return <LinearLoader />
    }

    return (
        <>
            <Helmet>
                <title>{getPageTitleByDomain("Event Links")}</title>
            </Helmet>
            <Container maxWidth={false}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <LinksSection currentEvent={event} />
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}
